import component from "./Pipeline"
import mobile from "./Pipeline"

export default { 
    component,
    urlHash: "#pipeline",
    mobile,
}